// src/redux/slices/tokenSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface Token {
  id: number;
  userId: number;
  modelType: string;
  tokenCount: number;
  createdAt: string;
  updatedAt: string;
}

interface TokenState {
  tokens: Token[];
  loading: boolean;
  error: string | null;
}

export const initialState: TokenState = {
  tokens: [],
  loading: false,
  error: null,
};

const tokenSlice = createSlice({
  name: "tokens",
  initialState,
  reducers: {
    setTokens: (state, action: PayloadAction<Token[]>) => {
      state.tokens = action.payload;
      state.loading = false;
      state.error = null;
    },
    addToken: (state, action: PayloadAction<Token>) => {
      const existingIndex = state.tokens.findIndex(
        (token) => token.modelType === action.payload.modelType
      );

      if (existingIndex >= 0) {
        state.tokens[existingIndex] = action.payload;
      } else {
        state.tokens.push(action.payload);
      }

      state.loading = false;
      state.error = null;
    },
    setTokenLoading: (state) => {
      state.loading = true;
      state.error = null;
    },
    setTokenError: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setTokens, addToken, setTokenLoading, setTokenError } =
  tokenSlice.actions;
export default tokenSlice.reducer;
